module.exports = __webpack_public_path__ + "static/media/hired.a2a58611.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/get-started/hired.png
// module id = 1531
// module chunks = 3